import JsBarcode from 'jsbarcode';
import moment from 'moment';
import 'moment/locale/tr';
import QRCode from 'qrcode';
import { setPrintedColumnTrue } from '../api';
import ukLogo from './uk.png';

const groupVehicles = (chassis_details) => {
    const groups = {};

    chassis_details.forEach(vehicle => {
        const key = `${vehicle.brand}_${vehicle.target}`;
        if (!groups[key]) {
            groups[key] = {
                brand: vehicle.brand,
                target: vehicle.target,
                vehicles: []
            };
        }
        groups[key].vehicles.push(vehicle);
    });

    return Object.values(groups);
};

const generateBarcode = (value) => {
    try {
        const canvas = document.createElement('canvas');
        JsBarcode(canvas, value, {
            format: 'CODE128',
            width: 2,
            height: 50,
            displayValue: true,
            fontSize: 12,
            margin: 10,
        });
        return canvas.toDataURL('image/png', 1.0);
    } catch (error) {
        console.error('Barkod oluşturma hatası:', error);
        return null;
    }
};

const generateQR = async (text) => {
    try {
        return await QRCode.toDataURL(text);
    } catch (err) {
        console.error('QR Code generation error:', err);
        return null;
    }
};

export const Grupaj = async (dataArray, selectedData, onFilter) => {
    // dataArray'i tekil data için de çalışacak şekilde düzenle
    const dataList = Array.isArray(dataArray) ? dataArray : [dataArray];

    // Call setPrintedColumnTrue immediately for each groupage
    try {
        await Promise.all(dataList.map(data =>
            setPrintedColumnTrue({ groupage_no: data.groupage_no })
        ));
        // Call onFilter immediately after updating print status
        if (typeof onFilter === 'function') {
            onFilter();
        }
    } catch (error) {
        console.error('Error updating print status:', error);
    }

    const iframe = document.createElement('iframe');
    document.body.appendChild(iframe);
    iframe.style.position = 'absolute';
    iframe.style.left = '-9999px';

    const generateContent = async (data, selected) => {
        const vehicleGroups = groupVehicles(data.chassis_details);
        const barcode = generateBarcode(data.groupage_no);
        const qr_image = await generateQR(data.groupage_no);

        // Convert logo to base64
        let logoBase64 = '';
        try {
            const response = await fetch(ukLogo);
            const blob = await response.blob();
            const reader = new FileReader();
            logoBase64 = await new Promise((resolve) => {
                reader.onloadend = () => resolve(reader.result);
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error('Logo yükleme hatası:', error);
        }

        // Initialize loading and unloading groups
        const loadingGroups = {};
        const unloadingGroups = {};

        // Process chassis details for grouping
        if (data.chassis_details) {
            data.chassis_details.forEach(vehicle => {
                const exitWarehouse = vehicle.exit_warehouse || '';
                if (!loadingGroups[exitWarehouse]) {
                    loadingGroups[exitWarehouse] = {
                        name: exitWarehouse,
                        count: 0
                    };
                }
                loadingGroups[exitWarehouse].count++;

                // Unloading groups based on target and city
                const key = `${vehicle.target}-${vehicle.city_name}`;
                if (!unloadingGroups[key]) {
                    unloadingGroups[key] = {
                        address: `${vehicle.target}-${vehicle.city_name} ${vehicle.address ? '- ' + vehicle.address : ''}`,
                        count: 0
                    };
                }
                unloadingGroups[key].count++;
            });
        }

        // Sort loading groups by name
        const sortedLoadingGroups = Object.values(loadingGroups).sort((a, b) =>
            a.name.localeCompare(b.name, 'tr')
        );
        // Sort unloading groups by address
        const sortedUnloadingGroups = Object.values(unloadingGroups).sort((a, b) =>
            a.address.localeCompare(b.address, 'tr')
        );

        return `
            <div style="page-break-after: always;">
                <div class="header">
                    <div class="logo-section">
                        <img width="60" height="60" src="${logoBase64}" alt="Company Logo" class="logo" />
                        <div class="company-info">
                            <div><i class="far fa-envelope"></i> info@uklojistik.com</div>
                            <div><i class="fas fa-globe"></i> www.uklojistik.com</div>
                            <div><i class="fas fa-phone"></i> +90 (216) 688 08 98</div>
                        </div>
                    </div>
                    <div class="header-right">
                        <div class="date">
                            Tarih ${moment().format('DD.MM.YYYY HH:mm:ss')}
                        </div>
                    </div>
                </div>

                <div class="location-section">
                    <div class="main-locations">
                        <div class="location">
                            ${selected?.from_warehouse_name || data.from_warehouse_name || ''}
                            <br /> ${selected?.to_warehouse_name || data.to_warehouse_name || ''}
                        </div>
                        <div class="barcode-section" style="margin-left:20mm;">
                            <img src="${qr_image}" class="barcode" />
                        </div>
                        <div class="barcode-section">
                            <img src="${barcode}" class="barcode" />
                        </div>
                    </div>
                    <div class="grupaj-info">
                        <div class="grupaj-left" style="display: flex; justify-content: space-between; width: 50%;">
                            <div>
                                <div class="grupaj-line">
                                    <span>Grupaj No:</span>
                                </div>
                                <div class="grupaj-line">
                                    <span>İl:</span>
                                </div>
                            </div>
                            <div>
                                <div class="grupaj-line">
                                    <span>${data.groupage_no}</span>
                                </div>
                                <div class="grupaj-line">
                                    <span>${data.chassis_details?.[0]?.city_name || ''}</span>
                                </div>
                            </div>
                        </div>
                        <div class="grupaj-center">
                            <div class="grupaj-line">
                                <span>Grupaj Tarih</span>
                            </div>
                            <div class="grupaj-line">
                                <span>En Geç Tarih</span>
                            </div>
                        </div>
                        <div class="grupaj-right">
                            <div class="grupaj-line">${moment(data.create_date).format('DD.MM.YYYY HH:mm:ss')}</div>
                            <div class="grupaj-line">-</div>
                        </div>
                    </div>
                </div>

                <div class="document-title">
                    Sevkiyat Detay Bilgileri - Toplam ${data.chassis_details?.length || 0} Otomobildir.
                </div>

                <table class="vehicle-table">
                    <thead>
                        <tr>
                            <th>-</th>
                            <th style="text-align:center;">Şase No</th>
                            <th style="text-align:center;">Model Adi</th>
                            <th style="text-align:center;">Renk Adı</th>
                            <th style="text-align:center;">Yükleme Yeri</th>
                            <th style="text-align:center;">Sevk Yeri</th>
                            <th style="text-align:center;">Sevk İl</th>
                            <th style="text-align:center;">Araç Park Yeri</th>
                            <th style="text-align:center;">Peron</th>
                            <th style="text-align:center; width: 80px;">Yükleme Alanı</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${data.chassis_details?.map((vehicle, index) => `
                            <tr>
                                <td>${index + 1}</td>
                                <td>${vehicle.chassis_no || ''}</td>
                                <td>${vehicle.model || ''}</td>
                                <td>${vehicle.color || ''}</td>
                                <td>${vehicle.exit_warehouse || ''}</td>
                                <td>${vehicle.target}-${vehicle.city_name || ''}/${vehicle.district_name || ""}</td>
                                <td>${vehicle.city_name || ''}</td>
                                <td>${vehicle.park_address || ''}</td>
                                <td style="text-align: left;">
                                    ${vehicle.groupage_peron || ''}
                                </td>
                                <td style="width: 80px; text-align: center;">${vehicle.loading_dock || ''}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>

                <div class="summary-section">
                    <table class="summary-table">
                        <thead>
                            <tr>
                                <th colspan="2" style="border: none; text-align: center;" class="summary-header">Yükleme Özeti</th>
                                <th colspan="2" style="border: none; text-align: center;" class="summary-header">Boşaltma Özeti</th>
                            </tr>
                            <tr>
                                <th class="address-header">Yükleme Yeri Adresi</th>
                                <th class="quantity-header">ADET</th>
                                <th class="address-header">Boşaltma Yeri Adresi</th>
                                <th class="quantity-header">ADET</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${(() => {
                const maxRows = Math.max(sortedLoadingGroups.length, sortedUnloadingGroups.length);
                return Array.from({ length: maxRows }, (_, i) => {
                    const loadingEntry = sortedLoadingGroups[i] || { name: '', count: '' };
                    const unloadingEntry = sortedUnloadingGroups[i] || { address: '', count: '' };
                    return `
                                        <tr>
                                            <td class="address-cell">${loadingEntry.name}</td>
                                            <td class="quantity-cell">${loadingEntry.count}</td>
                                            <td class="address-cell">${unloadingEntry.address}</td>
                                            <td class="quantity-cell">${unloadingEntry.count}</td>
                                        </tr>
                                    `;
                }).join('')
            })()}
                        </tbody>
                    </table>
                </div>

                <table class="signature-table">
                    <tr>
                        <td width="50%">
                            <table class="inner-signature-table">
                                <tr>
                                    <td colspan="2" class="title">TESLİM EDEN</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="name">Personel Adı Soyadı:</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="signature-space"></td>
                                </tr>
                            </table>
                        </td>
                        <td width="50%">
                            <table class="inner-signature-table">
                                <tr>
                                    <td colspan="2" class="title">TESLİM ALAN</td>
                                </tr>
                                <tr>
                                    <td class="label">Taşıyıcı Firma:</td>
                                    <td>${data.truck_subcontractor_name || ''}</td>
                                </tr>
                                <tr>
                                    <td class="label">Plaka/Dorse:</td>
                                    <td>${data?.plate_number || ''} ${data?.trailer_plate ? '/ ' + data.trailer_plate : ''}</td>
                                </tr>
                                <tr>
                                    <td class="label">Şoför:</td>
                                    <td>${data?.driver_name || ''}</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="signature-space"></td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </div>
        `;
    };

    // Tüm grupajların içeriğini oluştur
    const allContent = await Promise.all(dataList.map((data, index) => generateContent(data, selectedData?.[index])));

    const styles = `
        @page { 
        size: A4 landscape; 
        margin: 0;
      }
      
      body { 
        font-family: 'Times New Roman', sans-serif;
        margin: 0;
        padding: 0;
        font-size: 11px;
        line-height: 1.2;
      }

      .header {
        display: flex;
        justify-content: space-between;
        padding: 10px 20px;
      }

      .logo-section {
        display: flex;
        gap: 10px;
      }

      .logo {
        width: 60px;
        height: 60px;
      }

      .company-info {
        line-height: 1.4;
      }

      .company-info i {
        width: 15px;
      }

      .header-right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 5px;
      }

      .date {
        font-size: 16px;
        margin-top: 5px;
      }

      .barcode {
        height: 55px;
      }

      .location-section {
        padding: 0 20px;
        margin-bottom: 15px;
      }

      .main-locations {
        font-weight: bold;
        font-size: 14px;
        line-height: 1.3;
        display: flex;
        justify-content: space-between;
      }

      .grupaj-info {
        display: grid;
        grid-template-columns: 2fr 1fr 1fr;
        margin-top: 10px;
        align-items: flex-end;
        padding-bottom: 0px;
        margin: 0;
      }

      .grupaj-line {
        width: max-content;
        margin-bottom: 5px;
      }

      .document-title {
        text-align: center;
        font-weight: bold;
        margin: 15px 20px;
      }

      .vehicle-table, .summary-table {
        width: calc(100% - 40px);
        margin: 0 20px 15px;
        border-collapse: collapse;
      }

      .vehicle-table th,
      .vehicle-table td,
      .summary-table th,
      .summary-table td {
        border: 1px solid black;
        padding: 4px;
        text-align: left;
      }

      .vehicle-table th {
        font-weight: normal;
      }

      .summary-table .summary-header {
        font-weight: bold;
      }
      
      .summary-table .address-header {
        font-weight: normal;
        text-align: center;
      }
      
      .summary-table .quantity-header {
        width: 60px;
        text-align: center;
        font-weight: normal;
      }
      
      .summary-table .quantity-cell {
        text-align: center;
      }
      
      .summary-table .address-cell {
        text-align: left;
      }

      .signature-table {
        width: calc(100% - 40px);
        margin: 20px 20px;
      }

      .inner-signature-table {
        width: 100%;
        height: 200px;
      }

      .inner-signature-table td {
        padding: 4px 0;
      }

      .inner-signature-table .title {
        font-weight: bold;
        margin-bottom: 10px;
      }

      .inner-signature-table .label {
        width: 100px;
        vertical-align: top;
        text-align: right;
        padding-right: 10px;
      }

      .signature-space {
        height: 80px;
      }

      .summary-header {
        text-align: center;
        font-weight: bold;
      }

      .address-header, .quantity-header, .address-cell{
        width: 50%;
        text-align: center;
        padding: 8px;
        border: 1px solid #ddd;
      }

      .address-cell {
        text-align: left;
      }
    `;

    iframe.contentDocument.write(`
        <!DOCTYPE html>
        <html>
            <head>
                <title>Grupaj Dökümanları</title>
                <style>${styles}</style>
            </head>
            <body>
                ${allContent.join('')}
            </body>
            <script>
                window.onload = async function() {
                    window.print();
                    window.onafterprint = function() { 
                        document.body.removeChild(iframe);
                    };
                };
            </script>
        </html>
    `);

    iframe.contentDocument.close();
};
